var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isInternalUser)?_c('external-subgroup-context-picker',{staticClass:"external"}):_c('internal-subgroup-context-picker')}
var staticRenderFns = []

export { render, staticRenderFns }